import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'

import Home from './pages/Home'
import Login from './pages/Login'

import { unregister } from './registerServiceWorker'     
unregister()     

Object.defineProperty(Storage.prototype, "user", {
  configurable: true,
  enumerable: false,
  get: () => {
    const user = sessionStorage.getItem("user")
    if (user == null) {
      return null
    }
    try {
      return JSON.parse(user)
    } catch (e) {
      sessionStorage.removeItem("user")
      return null
    }
  },
  set: (user) => {
    if (user == null || !user.username) {
      sessionStorage.removeItem("user")
    } else {
      let json = JSON.stringify(user)
      sessionStorage.setItem("user", json)
    }
  },
})

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    sessionStorage.user ? (
      <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }}/>
    )
  )}/>
)

const getTheme = () => {
  let overwrites = {
    palette: {
    },
  }
  return getMuiTheme(baseTheme, overwrites)
}

const App = (props) => (
  <Router>
    <div>
      <PrivateRoute exact path="/" component={Home}/>
      <Route exact path="/login" component={Login}/>
    </div>
  </Router>
)

ReactDOM.render(
  <MuiThemeProvider muiTheme={getTheme()}>
    <App />
  </MuiThemeProvider>,
  document.getElementById('root')
)




// WEBPACK FOOTER //
// ./src/index.js